module.exports = "https://cdn.littlereply.com/tt/resource/earn_guide_step_4@3x.362f055d2ba626e7fca53cbfe99a789c.png";